import React, { useMemo } from 'react';
import { shape, bool, instanceOf, func } from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import CTTableRow from './CTTableRow';
import NoDefinition from './NoDefinition';

const CTTableBody = ({ definition, setSelectedTargets, loadMore, setView, handleAction }) => {
  const _handleOnRowSelect = (checkSate, row) => {
    setSelectedTargets(checkSate, row);
  };
  const renderTableRow = useMemo(
    () => (
      <CTTableRow
        handleOnRowSelect={_handleOnRowSelect}
        data={definition.data}
        loading={definition.loading}
        handleAction={handleAction}
      />
    ),
    [definition.data]
  );

  const _renderTbody = () => {
    let renderView = null;
    if (definition.loading && definition.data.length === 0) {
      renderView = (
        <div style={{ padding: '20px', textAlign: 'center' }}>loading...</div>
      );
    } else if (!definition.loading && definition.data.length === 0) {
      if (definition.hasDefinition) {
        renderView = (
          <div
            style={{
              padding: '20px',
              textAlign: 'center',
              marginTop: '10%',
              fontSize: '18px',
              color: '#808080'
            }}
          >
            No targets matching your search request were found. Please try another search.  
          </div>
        );
      } else {
        renderView = <NoDefinition setView={setView} />;
      }
    }
    return renderView;
  };

  return (
    <div className="de--table__body de--flex-col-1">
      {_renderTbody()}
      {definition.data.length > 0 && (
        <InfiniteScroll
          pageStart={definition.response.currentPage}
          loadMore={loadMore}
          hasMore={definition.response.hasMorePages}
          useWindow={false}
          threshold={10}
          loader={
            <div className="table-loader" key={0}>
              Loading ...
            </div>
          }
        >
          {renderTableRow}
        </InfiniteScroll>
      )}
    </div>
  );
};

CTTableBody.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
  setSelectedTargets: func,
  loadMore: func,
  setView: func,
  handleAction: func,
};

CTTableBody.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
  },
};

export default CTTableBody;
